exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.avatar {\n  min-width: 64px;\n  width: 64px;\n  height: 64px;\n}\n.avatar--sm {\n  min-width: 38px;\n  width: 38px;\n  height: 38px;\n}\n.avatar--md {\n  min-width: 50px;\n  width: 50px;\n  height: 50px;\n}\n.avatar--lg {\n  min-width: 100px;\n  width: 100px;\n  height: 100px;\n}\n.avatar__loading {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.5);\n}", ""]);

// exports
